import React from 'react';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import SiteQualifyingEvents from './SiteQualifyingEvents';
import SiteStormLogs from './SiteStormLogs';
import SiteRainLogsHourly from './SiteRainLogsHourly';
import SiteRainLogsCalendar from './SiteRainLogsCalendar';
import SectionHeaderWithIcon, { SectionHeaderTypes } from '../../Common/SectionHeaderWithIcon';

export default function SiteRainLogsContainer({ siteQualifyingEventLogsData, siteStormLogsData, siteRainLogsData, sectionName, sectionIcon, site }) {

    function handlePrint(headerText, tableSelector) {
        let tableId = tableSelector.replace("#", "");
        let table = document.getElementById(tableId);
        table.classList.add("print");

        const doc = new jsPDF({ orientation: 'p', unit: 'px', format: 'a4', });
        doc.setTextColor(40, 68, 90);
        doc.setFont(undefined, 'bold');

        let finalY = 0;
        doc.text(site.siteName, 33, finalY + 22);
        doc.text(headerText, 33, finalY + 40);
        doc.autoTable({
            html: tableSelector,
            theme: 'plain',
            startY: finalY + 50,
            headStyles: { lineWidth: { bottom: .25 }, textColor: '#28445a' },
            bodyStyles: { lineWidth: { bottom: .25 } },
        });

        // finalY = doc.lastAutoTable.finalY;

        table.classList.remove("print");

        doc.save(`${site.siteName}-${headerText}.pdf`);
    }

    let buttonContainer;
    let siteQualifyingEventLogs;
    if (siteQualifyingEventLogsData !== undefined) {
        siteQualifyingEventLogs = siteQualifyingEventLogsData.loading && "Loading";
        if (siteQualifyingEventLogsData.loading === false && siteQualifyingEventLogsData.logs) {
            siteQualifyingEventLogs = (<SiteQualifyingEvents
                logTypeName="Qualifying Events:"
                logs={siteQualifyingEventLogsData.logs}
                hide={false}
                onPrint={handlePrint}
            />);
        }
    }

    let siteStormLogs;
    if (siteStormLogsData !== undefined) {
        siteStormLogs = siteStormLogsData.loading && "Loading";
        if (siteStormLogsData.loading === false && siteStormLogsData.logs) {
            siteStormLogs = (<SiteStormLogs
                logTypeName="Storm Logs:"
                logs={siteStormLogsData.logs}
                hide={false}
                onPrint={handlePrint}
            />);
        }
    }

    let siteRainLogs;
    if (siteRainLogsData !== undefined) {
        siteRainLogs = siteRainLogsData.loading && "Loading";
        if (siteRainLogsData.loading === false && siteRainLogsData.logs) {
            if (siteRainLogsData.logs.hourlyRainLog?.length) {
                siteRainLogs = (<SiteRainLogsHourly
                    logTypeName="Rain Logs:"
                    logs={siteRainLogsData.logs.hourlyRainLog}
                    hide={false}
                    onPrint={handlePrint}
                />);
            }
            else if (siteRainLogsData.logs.calendarDayRainLog?.length) {
                siteRainLogs = (<SiteRainLogsCalendar
                    logTypeName="Rain Logs:"
                    logs={siteRainLogsData.logs.calendarDayRainLog}
                    hide={false}
                    onPrint={handlePrint}
                />);
            }
        }
    }

    buttonContainer = (<div className="buttonContainer flexbox-flex justify-between">
        <button onClick={() => handlePrint("Qualifying Events", "#qualifyingEvents")}>Print</button>
        <button onClick={() => handlePrint("Storm Logs", "#stormLogs")}>Print</button>
        <button onClick={() => handlePrint("Rain Logs", "#rainLogs")}>Print</button>
    </div>);

    return (<>
        <SectionHeaderWithIcon sectionName={sectionName} sectionIcon={sectionIcon} sectionHeaderType={SectionHeaderTypes.Primary} classes="" />
        <div className="logsContainer">
            {siteQualifyingEventLogs}
            {siteStormLogs}
            {siteRainLogs}
        </div>
    </>);
}